import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from '@/i18n'
import '@/sass/overrides.sass'
// import fr from 'vuetify/lib/locale/fr'  // Importation de la langue française

Vue.use(Vuetify)

const theme = {
  primary: '#4267B2',
  success: '#4267B2',
  // primary: 'primary',
  secondary: '#4267B2',
  accent: '#4267B2',
  info: '#4267B2',
}

export default new Vuetify({
  lang: {
    // locales: { fr },
    // current: 'fr',
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
})
